import {mapActions, mapGetters, mapState} from 'vuex'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
const menu = {
  '认证审核': RoutePathConstants.CERTIFICATION_AUDIT_VIEW,
  '卡劵操作': RoutePathConstants.CARD_OPERATION_SEARCH,
  '核销操作': RoutePathConstants.WRITE_OFF_OPERATION,
  '我的记录': RoutePathConstants.GO_OUT_MY_RECORD
}
export default {
  data () {
    return {
      radio1: ''
    }
  },
  computed: {
    ...mapState('wxMemberModule', []),
  },
  methods: {
    ...mapActions('wxMemberModule', []),
    clickMenu (val) {
      this.$router.push({
        path: menu[val]
      })
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/components/go-out-management.js